import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { capitalizeFirstLetter } from '../../utils';

const ProfileDropDown = ({ isOpen, setIsOpen, profile }) => {
  const handleLogOut = () => {
    Cookies.remove('_session_id');
    window.location.reload();
  };
  return (
    <>
      <div className="p-3">
        <span className="block text-sm text-gray-900">
          {profile?.register_as === 'corporate'
            ? capitalizeFirstLetter(profile?.corporation_name)
            : `${capitalizeFirstLetter(
                profile?.given_name,
              )} ${capitalizeFirstLetter(profile?.other_names)}`}
        </span>
        <span className="block text-sm font-medium text-gray-500 truncate">
          {profile?.email}
        </span>
      </div>
      <ul className="divide-y divide-gray-100">
        <li>
          <Link
            to="/profile"
            className="block p-3 text-base text-gray-700 hover:bg-gray-100"
            style={{ textDecoration: 'none', color: 'inherit' }}
            onClick={() => setIsOpen(!isOpen)}
          >
            Profile
          </Link>
        </li>
        <li>
          <Link
            to="/password-change"
            className="block p-3 text-base text-gray-700 hover:bg-gray-100"
            style={{ textDecoration: 'none', color: 'inherit' }}
            onClick={() => setIsOpen(!isOpen)}
          >
            Change Password
          </Link>
        </li>
        <li>
          <button
            type="button"
            className="block w-full p-3 text-base text-left text-gray-700 hover:bg-gray-100"
            onClick={handleLogOut}
          >
            Logout
          </button>
        </li>
      </ul>
    </>
  );
};

ProfileDropDown.defaultProps = {
  profile: {},
  isOpen: false,
  setIsOpen: null,
};

ProfileDropDown.propTypes = {
  profile: PropTypes.shape({
    email: PropTypes.string,
    given_name: PropTypes.string,
    other_names: PropTypes.string,
    corporation_name: PropTypes.string,
    register_as: PropTypes.string,
  }),
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
};

export default ProfileDropDown;
